<template>
    <v-container v-if="superUser || permissions.read" fluid class="b-container">
        <v-sheet class="pa-3">
            <v-tabs
                v-model="tab"
                :vertical="$vuetify.breakpoint.smAndDown"
                color="secondary"
            >
                <v-tab
                    v-for="tab in tabs"
                    :key="tab.name['en']"
                    v-text="tab.name[lang]"
                    :to="tab.to"
                    class="text-capitalize px-3"
                ></v-tab>
            </v-tabs>
        </v-sheet>

        <v-tabs-items v-model="tab" class="mt-3">
            <router-view></router-view>
        </v-tabs-items>
    </v-container>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: "Redeem",

    data() {
        return {
            tab: this.$route.path,
        };
    },

    computed: {
        ...mapState(["superUser"]),

        lang() {
            return this.$route.params.lang;
        },

        permissions() {
            return this.$store.state.permissions.redemption
                ? this.$store.state.permissions.redemption
                : {};
        },

        tabs() {
            let arr = [];

            if (this.superUser || this.permissions.redeem_voucher) {
                arr.push({
                    to: `/${this.lang}/storePanel/redeem/redeem-voucher-code`,
                    name: {
                        el: "Εξαργύρωση κωδικού Κουπονιού",
                        en: "Redeem Voucher Code",
                        it: "Riscattare codice del Buono ",
                    },
                });
            }

            if (this.superUser || this.permissions.coupons_overview) {
                arr.push({
                    to: `/${this.lang}/storePanel/redeem/coupons-overview?page=1`,
                    name: {
                        el: "Επισκόπηση Κουπονιών",
                        en: "Coupons Overview",
                        it: "Panoramica dei coupon",
                    },
                });
            }

            if (this.superUser || this.permissions.multiple_coupons) {
                arr.push({
                    to: `/${this.lang}/storePanel/redeem/multiple-coupons?page=1`,
                    name: {
                        el: "Πολλαπλά Κουπόνια",
                        en: "Multiple Coupons",
                        it: "Coupon multipli",
                    },
                    show: this.superUser || this.permissions.multiple_coupons,
                });
            }

            return arr;
        },
    },

    watch: {
        tabs: {
            immediate: true,
            handler(val) {
                if (val.length) {
                    if (!this.permissions.read && !this.superUser) {
                        this.$router.replace(
                            `/${this.lang}/storePanel/forbidden-gateway`
                        );
                    } else if (
                        this.$route.path === `/${this.lang}/storePanel/redeem`
                    ) {
                        this.$router.replace(val[0].to);
                    }
                }
            },
        },
    },
};
</script>
